export default __webpack_public_path__ + "static/media/ic-supp-silage.f0b96e4d.svg";